/**
 * useEnabledTrackers — the trackers this deployment can read (GET /app-env
 * `trackers`). Voluum and Binom always; any other tracker only once the backend
 * reports it configured. While the query loads, after an error, or from an older
 * backend that omits the field: the defaults.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useMemo } from 'react';
import { DEFAULT_ENABLED_TRACKERS, TRACKER_IDS, type TrackerId } from '@trafficpulse/shared';

import { useAppEnv } from '@/features/app-env';

/** Defaults plus every other known tracker the backend reported, in registry order. */
export function enabledTrackers(reported: unknown): readonly TrackerId[] {
  if (!Array.isArray(reported)) return DEFAULT_ENABLED_TRACKERS;
  const extra = TRACKER_IDS.filter(
    (id) => !DEFAULT_ENABLED_TRACKERS.includes(id) && reported.includes(id),
  );
  return extra.length === 0 ? DEFAULT_ENABLED_TRACKERS : [...DEFAULT_ENABLED_TRACKERS, ...extra];
}

export function useEnabledTrackers(): readonly TrackerId[] {
  const { data, isError } = useAppEnv();
  const reported = isError ? undefined : data?.trackers;
  return useMemo(() => enabledTrackers(reported), [reported]);
}
